<!-- 混合模式疑答 -->
<template>
  <div class="discuss_wrap">
    <el-form v-if="!isEdit" label-position="top" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="主题" prop="name">
            <el-input v-model="ruleForm.discussSearchValue"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="desc">
            <el-input type="textarea" v-model="ruleForm.desc"></el-input>
        </el-form-item>
    </el-form>
    <div v-if="!isEdit" class="btn_wrap">
        <el-button type="primary" size="small" @click="addDiscuss">发表</el-button>
    </div>
    <div v-if="!isEdit" class="show_list">
        <div class="title">
            <div>中联教师<el-tag class="tag" size="mini">教师</el-tag></div>
            <div class="time">昨天16:16</div>
        </div>
        <div class="quest">这道题怎么做</div>
        <div class="quest_type">全部章节</div>
    </div>
    <div v-if="isEdit" class="show_list">
        <div class="title">
            <div>这道题怎么做</div>
        </div>
        <div class="quest">这道题难</div>
        <div class="quest_type">中联教育 <div class="date">昨天16:16</div></div>
    </div>
    <el-form style="margin-top:20px;" v-if="isEdit" label-position="top" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="" prop="desc">
            <el-input style="height: 100px;" placeholder="欢迎留言交流" maxlength="300"
  show-word-limit type="textarea" v-model="ruleForm.desc"></el-input>
        </el-form-item>
    </el-form>
    <div v-if="isEdit" class="btn_wrap">
        <el-button type="primary" size="small">发表留言</el-button>
    </div>
    <div v-if="isEdit" class="list">
        <div>全部回复  3</div>
        <div class="answer_list">
            <div>啥也不会</div>
            <div class="title">
                <div>中联教师<el-tag class="tag" size="mini">教师</el-tag></div>
                <div class="time">昨天16:16</div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import * as api from "../../../api/discussApi";
export default {
  data() {
   return {
       ruleForm:{},
       isEdit: false,
       rules: {
          name: [
            { required: true, message: '请输入活动名称', trigger: 'blur' },
            { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
          ],
       }
   }
  },
  created() {

  },
  methods: {
    getDiscussList(currentpage){
      let obj = {
        courseId: sessionStorage.getItem('courseId'),
        classId: sessionStorage.getItem('classId'),
        type: 0,
        name: this.ruleForm.discussSearchValue,
        catalogId: null,
        myContent: this.ruleForm.desc, //只看我的
        repliedOrParticipationFlag: this.teacherPartake?1:0, //老师已答复、参与
        discussionAreaId: 3, //1全部、2老师、3课堂
        pageSize: this.pageTotal.pageSize,
        pageNum: currentpage
      }
      api.getDiscussList(obj).then(rs=>{
        this.discussList = rs.data.list
        this.pageTotal = {
          currentpage: rs.data.pageNum,
          pageSize: rs.data.pageSize,
          total: rs.data.total
        }
      })
    },
    addDiscuss(){
      let obj = {
          discussionAreaId: this.regionValue,
          theme: this.ruleForm.discussSearchValue,
          content: this.ruleForm.desc,
          courseId: sessionStorage.getItem('courseId'),
          classId: sessionStorage.getItem('classId'),
        //   catalogId: chapter,
          resourceId: null,
          resourceType: null,
          anonymous: this.isAnonymousValue?0:1, //0匿名、1公开
          roofPlacement: this.isTopValue?1:0, //0不置顶、1置顶
        //   catalogIds: catalogIds
        }
        console.log(obj)
        // request = api.publishDiscuss(obj);
    },
  }
}
</script>
<style lang='scss' scoped>
/* @import url(); 引入css类 */
.discuss_wrap{
    width: 100%;
    height: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    .btn_wrap{
        text-align: right;
    }
}
.show_list{
    width:100%;
    padding: 20px;
    margin-top: 20px;
    box-sizing: border-box;
    border: 1px solid #DCDFE6;
    .title{
        display: flex;
        justify-content: space-between;
        align-items: center;
        .tag{
            margin-left: 20px;
        }
        .time{
            font-size: 14px;
            color: #999999;
        }
    }
    .quest{
        margin-top: 20px;
    }
    .quest_type{
        margin-top: 15px;
        color: #999;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        .date{
            margin-left: 20px;
            font-size: 14px;
            color: #999999;
        }
    }
}
.demo-ruleForm /deep/ .el-textarea__inner{
    width: 100%;
    height: 100%;
}
.list{
    &>div{
        padding: 20px 0;
        border-bottom: 1px solid #DCDFE6;
    }
    .answer_list{
        display: flex;
        flex-direction: column;
        .title{
            margin-top:20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .tag{
                margin-left: 20px;
            }
            .time{
                font-size: 14px;
                color: #999999;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/subcomponent/discuss/discuss.vue